import useScroll from '@/shared/hooks/useScroll.hook'
import { ApartSideFloatBtn } from '@/styles/Web/Apart/styled'

const ApartSideFloat = () => {
  const scroll = useScroll()

  return <ApartSideFloatBtn onClick={() => scroll.handleTop()} />
}

export default ApartSideFloat
